//
// PositionedModelController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "@sas-dvr/ltjs-commons/layout/LayoutProxy";
import "../visualElements/VisualElementTypeInfo";

var PositionedModelController = createModule("BIRD::PositionedModelController", ["BIRD::BIRDModelController"], EventDispatcher, [
    ,
    ,
    ,
    {
        parent: 1,
        layoutProxy: 1,
        w: 1,
        x: 1,
        h: 1,
        y: 1,
    },
    {
        getRelativeBounds: [12],
        setSelected: [0,2],
        canConvert: [2],
        getPadding: [1],
        getBorderThickness: [1],
        convert: [0,1],
        getZIndex: [4],
        getAllConversions: [[1]],
        isPaddingAvailable: [2],
        getRecommendedConversion: [1],
        setMaximized: [0,2],
        getSpecificVisualElementTypeLabel: [7],
        isSelected: [2],
        refreshLayoutConstraints: [0],
    },
    ,
    ,
]);
export default PositionedModelController;
